"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var Path_1 = require("./Path");

var shape = prop_types_1.default.shape({
  node: prop_types_1.default.instanceOf(HTMLElement).isRequired,
  path: Path_1.Path.shape.isRequired,
  text: prop_types_1.default.string.isRequired
});

function create(path, text) {
  var node = document.createElement('div');
  return {
    path: path,
    node: node,
    text: text || path.join('.')
  };
}

function _render(element, item) {
  var parent = element.parentElement;
  parent.classList.add('formula-editor__completions');
  element.append(item.node);
}

function toCodeMirror(hint) {
  return {
    render: function render(element) {
      return _render(element, hint);
    },
    text: hint.text
  };
}

exports.Hint = {
  create: create,
  render: _render,
  shape: shape,
  toCodeMirror: toCodeMirror
};